(() => {
  'use strict';
  const readConfig = () => {
    try { return JSON.parse(document.getElementById('mosselia-config')?.textContent || '{}'); }
    catch { return {}; }
  };
  const config = readConfig();
  const root = config.root || '/';
  const bundles = [
    { id: 'b1', qty: 1, regular: 1990, price: 1990 },
    { id: 'b2', qty: 2, regular: 3980, price: 3600 },
    { id: 'b3', qty: 3, regular: 5970, price: 4800 },
  ];
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat('bg-BG', {
    style: 'currency', currency, maximumFractionDigits: 2,
  }).format(cents / 100);
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const track = (event, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  };
  const flavorProduct = flavor => config.products?.[flavor];
  const pricesFor = (bundle, flavors) => {
    const chosen = Array.from({length: bundle.qty}, (_,i) => flavors[i] || 'malina');
    const regular = chosen.reduce((sum,f) => sum + (flavorProduct(f)?.price ?? 1990), 0);
    const discount = bundle.qty >= 3 ? (config.discounts?.['3'] ?? 390) : bundle.qty >= 2 ? (config.discounts?.['2'] ?? 190) : 0;
    return {regular, price: chosen.reduce((sum,f) => sum + Math.max(0,(flavorProduct(f)?.price ?? 1990)-discount),0), currency: config.currency || 'EUR'};
  };
  const itemsFor = flavors => {
    const counts = new Map();
    for (const flavor of flavors) {
      const variantId = flavorProduct(flavor)?.variantId;
      if (!variantId) throw new Error('Този вкус още не е наличен за поръчка.');
      counts.set(variantId, (counts.get(variantId) || 0) + 1);
    }
    return [...counts].map(([id, quantity]) => ({id, quantity}));
  };
  const requests = async (url, options = {}) => {
    const r = await fetch(root + url, { ...options, headers: { 'Content-Type': 'application/json', ...(options.headers || {}) } });
    const data = await r.json();
    if (!r.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Операцията не беше завършена. Опитай отново.');
    return data;
  };
  const dialog = document.getElementById('mosselia-cart');
  let cartRequest = 0;
  let cartFocus = null;
  function closeCart() { if (dialog?.open) dialog.close(); }
  async function renderCart() {
    if (!dialog) return;
    const request = ++cartRequest;
    const content = dialog.querySelector('[data-cart-content]');
    const checkout = dialog.querySelector('[data-cart-checkout]');
    checkout.disabled = true;
    content.textContent = 'Зареждане…';
    try {
      const cart = await requests('cart.js');
      if (request !== cartRequest) return;
      const currency = cart.currency || config.currency || 'EUR';
      content.innerHTML = cart.items.length ? cart.items.map(item => `
        <article class="rounded-2xl border border-border bg-card p-4 mb-4">
          <div class="flex gap-3">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="80" height="80" loading="lazy" class="h-20 w-20 rounded-xl object-cover">` : ''}
          <div class="min-w-0"><p class="font-display text-base">${escape(item.product_title)}</p>
            <p class="text-xs text-muted-foreground">${escape(item.variant_title === 'Default Title' ? '' : item.variant_title || '')}</p>
            <p class="mt-2 text-sm">${item.quantity} × ${money(item.final_price, currency)}</p>${item.original_line_price > item.final_line_price ? `<p class="text-xs text-raspberry">Спестяваш ${money(item.original_line_price-item.final_line_price,currency)}</p>` : ''}
          </div></div>
          <div class="flex justify-between items-center mt-4"><button type="button" data-remove-cart="${escape(item.key)}" class="text-xs underline">Премахни</button><span class="font-medium">${money(item.final_line_price, currency)}</span></div>
        </article>`).join('') : '<p class="text-sm text-muted-foreground">Количката е празна. Избери своя пакет MOSSÉLIA.</p>';
      dialog.querySelector('[data-cart-total]').textContent = `Общо: ${money(cart.total_price, currency)}`;
      checkout.disabled = !cart.items.length;
    } catch (error) { content.textContent = error.message || 'Не успяхме да заредим количката.'; }
  }
  async function openCart() {
    if (!dialog) { window.location.assign(root + 'cart'); return; }
    cartFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    track('open_cart');
    await renderCart();
  }
  dialog?.addEventListener('close', () => cartFocus?.focus?.());
  dialog?.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart();
    }
  });
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-cart-open]')) await openCart();
    if (target.matches('[data-cart-close]')) closeCart();
    if (target.matches('[data-remove-cart]')) {
      target.disabled = true;
      try {
        await requests('cart/change.js', { method: 'POST', body: JSON.stringify({ id: target.dataset.removeCart, quantity: 0 }) });
        await renderCart();
      } catch (error) {
        target.disabled = false;
        dialog.querySelector('[data-cart-content]').append(document.createTextNode(error.message));
      }
    }
    if (target.matches('[data-menu-toggle]')) {
      const nav = document.getElementById('mosselia-mobile-menu');
      if (!nav) return;
      nav.hidden = !nav.hidden;
      target.setAttribute('aria-expanded', String(!nav.hidden));
    }
    if (target.closest('#mosselia-mobile-menu') && target.matches('a')) {
      document.getElementById('mosselia-mobile-menu').hidden = true;
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }
    if (target.matches('[data-gallery-thumb]')) {
      const gallery = target.closest('[data-gallery]');
      const image = target.querySelector('img');
      const main = gallery?.querySelector('[data-gallery-main]');
      if (!image || !main) return;
      main.srcset = image.dataset.fullSrcset || '';
      main.src = image.dataset.fullSrc || image.src;
      main.alt = image.alt;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(b => {
        const selected = b === target;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('border-sea', selected);
        b.classList.toggle('border-transparent', !selected);
      });
    }
  });
  function initializeSelectors(scope = document) {
    scope.querySelectorAll('[data-product-selector]').forEach(selector => {
      if (selector.dataset.initialized) return;
      selector.dataset.initialized = 'true';
      let bundle = bundles[1];
      let flavors = ['malina', 'ananas'];
      let busy = false;
      const find = key => selector.querySelector(`[data-${key}]`);
      const error = message => {
        find('selector-error').textContent = message;
        find('selector-error').hidden = !message;
      };
      function update() {
        const count = flavors.slice(0, bundle.qty).filter(Boolean).length;
        selector.querySelectorAll('[data-bundle]').forEach(button => {
          const selected = button.dataset.bundle === bundle.id;
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('border-sea', selected);
          button.classList.toggle('shadow-soft', selected);
          button.classList.toggle('border-border', !selected);
          const radio = button.querySelector('.bundle-radio');
          radio.textContent = selected ? '✓' : '';
          radio.classList.toggle('bg-sea', selected);
          radio.classList.toggle('border-sea', selected);
          radio.classList.toggle('text-primary-foreground', selected);
        });
        selector.querySelectorAll('[data-flavor-slot]').forEach(slot => { slot.hidden = Number(slot.dataset.flavorSlot) >= bundle.qty; });
        selector.querySelectorAll('[data-flavor]').forEach(button => {
          const selected = flavors[Number(button.dataset.slot)] === button.dataset.flavor;
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('border-sea', selected);
          button.classList.toggle('bg-accent/40', selected);
          button.classList.toggle('border-border', !selected);
        });
        const prices = pricesFor(bundle, flavors.slice(0, bundle.qty));
        find('flavor-count').textContent = `Избрани ${count} от ${bundle.qty} вкуса`;
        find('total-label').textContent = `Общо за ${bundle.qty} бр.`;
        find('total').textContent = money(prices.price, prices.currency);
        find('regular').textContent = money(prices.regular, prices.currency);
        find('regular').hidden = prices.regular <= prices.price;
        find('savings').textContent = `Спестяваш ${money(prices.regular - prices.price, prices.currency)}`;
        find('savings').hidden = prices.regular <= prices.price;
        find('unit').textContent = `${money(Math.round(prices.price / bundle.qty), prices.currency)} на буркан`;
        bundles.forEach(b => {
          const p = pricesFor(b, Array.from({ length: b.qty }, (_, i) => flavors[i] || 'malina'));
          selector.querySelector(`[data-card-price="${b.id}"]`).textContent = money(p.price, p.currency);
          selector.querySelector(`[data-card-unit="${b.id}"]`).textContent = `${money(Math.round(p.price / b.qty), p.currency)} / бр.`;
          const regular = selector.querySelector(`[data-card-regular="${b.id}"]`);
          regular.textContent = money(p.regular, p.currency); regular.hidden = p.regular <= p.price;
          const saving = selector.querySelector(`[data-card-saving="${b.id}"]`);
          saving.textContent = `−${money(p.regular - p.price, p.currency)}`; saving.hidden = p.regular <= p.price;
        });
        find('add-cart').textContent = busy ? 'Добавяне…' : count === bundle.qty ? 'ИЗБЕРИ СВОЯ ПАКЕТ' : `Избери още ${bundle.qty - count} вкус`;
        find('add-cart').disabled = busy || count !== bundle.qty;
      }
      selector.addEventListener('click', async event => {
        const button = event.target.closest('button');
        if (!button || busy) return;
        if (button.matches('[data-bundle]')) {
          bundle = bundles.find(b => b.id === button.dataset.bundle);
          flavors = flavors.slice(0, bundle.qty);
          error(''); update(); track('select_bundle', { bundle: bundle.id });
        }
        if (button.matches('[data-flavor]')) {
          flavors[Number(button.dataset.slot)] = button.dataset.flavor;
          error(''); update(); track('select_flavor', { flavor: button.dataset.flavor });
        }
        if (button.matches('[data-add-cart]')) {
          const chosen = flavors.slice(0, bundle.qty);
          if (chosen.filter(Boolean).length !== bundle.qty) return;
          if (chosen.some(f => !flavorProduct(f)?.variantId)) { error('Този вкус още не е наличен за поръчка.'); return; }
          if (chosen.some(f => !flavorProduct(f)?.available)) { error('Избраният вкус е изчерпан. Избери друга комбинация.'); return; }
          if (config.currency !== 'EUR') { error('Поръчките за MOSSÉLIA в евро все още се подготвят.'); return; }
          busy = true; error(''); update();
          try {
            await requests('cart/add.js', { method: 'POST', body: JSON.stringify({ items: itemsFor(chosen) }) });
            track('add_to_cart', { bundle: bundle.id, currency: config.currency, value: pricesFor(bundle, chosen).price / 100 });
            await openCart();
          } catch (err) { error(err.message || 'Не успяхме да добавим пакета. Опитай отново.'); }
          finally { busy = false; update(); }
        }
      });
      update();
    });
  }
  initializeSelectors();
  document.addEventListener('shopify:section:load', event => initializeSelectors(event.target));
  const buybox = document.getElementById('buybox');
  const sticky = document.querySelector('[data-sticky-buy]');
  if (buybox && sticky && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }).observe(buybox);
  if (dialog) dialog.querySelector('form')?.addEventListener('submit', () => track('begin_checkout'));
})();
